import { render, staticRenderFns } from "./AthleteView.vue?vue&type=template&id=77a95951&scoped=true"
import script from "./AthleteView.vue?vue&type=script&lang=js"
export * from "./AthleteView.vue?vue&type=script&lang=js"
import style0 from "./AthleteView.vue?vue&type=style&index=0&id=77a95951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a95951",
  null
  
)

export default component.exports